import React, { useState } from 'react';
import { X, Ticket, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PromoBanner = () => {
  const [dismissed, setDismissed] = useState(false);
  const navigate = useNavigate();

  if (dismissed) return null;

  return (
    <div className="relative overflow-hidden" data-testid="promo-banner">
      <div className="bg-gradient-to-r from-purple-700 via-pink-600 to-orange-500 px-4 py-3 sm:py-2.5">
        <div className="max-w-7xl mx-auto flex items-center justify-center gap-3 sm:gap-4 flex-wrap">
          <div className="flex items-center gap-2">
            <div className="flex items-center gap-1.5 bg-white/20 backdrop-blur-sm rounded-full px-3 py-1">
              <Ticket className="w-4 h-4 text-yellow-200" />
              <span className="text-xs font-bold text-yellow-200 tracking-wider uppercase">Limited Offer</span>
            </div>
          </div>
          <p className="text-white text-sm sm:text-base font-medium text-center">
            <span className="font-bold">7-Day Free Trial</span> on any plan
          </p>
          <button
            onClick={() => navigate('/pricing')}
            className="flex items-center gap-1 bg-white text-purple-700 px-4 py-1.5 rounded-full text-xs sm:text-sm font-bold hover:bg-yellow-100 transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
            data-testid="promo-cta-btn"
          >
            Try Free <ArrowRight className="w-3.5 h-3.5" />
          </button>
          <button
            onClick={() => setDismissed(true)}
            className="absolute right-2 top-1/2 -translate-y-1/2 text-white/60 hover:text-white transition-colors p-1"
            data-testid="promo-dismiss-btn"
            aria-label="Dismiss"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PromoBanner;
